"use client";

import { useRouter } from "next/navigation";
import AgentCard, { type AgentCardData } from "./AgentCard";

const MNR = "var(--font-manrope), 'Manrope', sans-serif";
const URB = "var(--font-urbanist), sans-serif";
const PJK = "'Plus Jakarta Sans', var(--font-plus-jakarta), sans-serif";

interface AgentCarouselProps {
  agents: AgentCardData[];
  onSelect?: (id: string) => void;
  onBrowseAll?: () => void;
}

export default function AgentCarousel({ agents, onSelect, onBrowseAll }: AgentCarouselProps) {
  const router = useRouter();
  const handleBrowseAll = () => {
    if (onBrowseAll) onBrowseAll();
    else router.push("/app/marketplace");
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 32,
        alignItems: "flex-start",
        width: "100%",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <h2
            style={{
              fontFamily: MNR,
              fontWeight: 600,
              fontSize: 20,
              lineHeight: "28px",
              letterSpacing: "-0.5px",
              color: "white",
              margin: 0,
            }}
          >
            Top Agents for Your Task
          </h2>
          <p
            style={{
              fontFamily: URB,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: "20px",
              color: "rgba(242,240,237,0.5)",
              margin: 0,
            }}
          >
            Based on your requirements and budget preferences.
          </p>
        </div>

        <button
          onClick={handleBrowseAll}
          className="app-text-link"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 4,
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 0,
            color: "#D5BAFF",
          }}
        >
          <span
            style={{
              fontFamily: PJK,
              fontWeight: 600,
              fontSize: 14,
              lineHeight: "20px",
              color: "#D5BAFF",
            }}
          >
            Browse all agents
          </span>
          <img
            src="/app-icons/arrow-right-violet.svg"
            alt=""
            style={{ width: 16, height: 16 }}
          />
        </button>
      </div>

      {/* Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
          gap: 16,
          width: "100%",
        }}
      >
        {agents.map((agent) => (
          <AgentCard key={agent.id} {...agent} onSelect={onSelect} />
        ))}
      </div>
    </div>
  );
}
